import {
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAIL,
  GET_UPDATED_ACTIVITY
} from "../actions/activity";

import { USER_LOGOUT } from "../actions/auth";

// const initialState = {
//   activities: [],
//   error: null
// };

const initialState = {};

const ActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: action.activities,
        error: null
      };
    case GET_ACTIVITIES_FAIL:
      return {
        ...state,
        activities: [],
        error: action.error
      }
    case GET_UPDATED_ACTIVITY: {
      const activities = state.activities || [];
      const { activities: updatedActivities } = action;

      updatedActivities.forEach(at => {
        activities.push(at);
      });
      
      return {
        ...state,
        isLoading: false,
        error: null,
        activities: [
          ...activities
        ]
      }
    }
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
}

export default ActivityReducer;
